import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

function Success() {
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [credentials, setCredentials] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const sessionId = params.get('session_id');

    if (sessionId) {
      fetch(`http://localhost:5000/api/session-details/${sessionId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            setError(data.error);
          } else {
            setCredentials(data);
          }
        })
        .catch(() => setError('Erro ao buscar dados da sessão'))
        .finally(() => setLoading(false));
    } else {
      setError('Session ID não encontrado na URL');
      setLoading(false);
    }
  }, [params]);

  if (loading) return <div style={{ padding: 20 }}>⏳ Carregando dados do pagamento...</div>;
  if (error) return <div style={{ padding: 20, color: 'red' }}>❌ {error}</div>;

  return (
    <div style={{ padding: 20 }}>
      <h2>✅ Pagamento confirmado</h2>
      <p>As credenciais abaixo foram geradas para você usar no sistema:</p>

      <div style={{ background: '#f9f9f9', padding: 15, borderRadius: 8 }}>
        <p><strong>Email:</strong> {credentials.email}</p>
        <p><strong>Access Key:</strong> <code>{credentials.accessKey}</code></p>
        <p><strong>Secret Key:</strong> <code>{credentials.secretKey}</code></p>
      </div>

      <p style={{ marginTop: 15, color: '#555' }}>
        Guarde essas informações com segurança. Você pode usá-las para acessar o sistema agora.
      </p>
    </div>
  );
}

export default Success;
